const SvgIconPlay = props => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
		focusable="false"
	>
		<path d="M8 5.8V14.2L15 10L8 5.8Z" fill="currentColor" />
	</svg>
);

export default SvgIconPlay;
